var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"info"},[_c('transition',{attrs:{"name":"pie-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPie),expression:"showPie"}],staticClass:"countdown-pie",style:({
        '--pct': _vm.remainingPct,
        '--pie-fg': _vm.pieColor,
        '--pie-bg': _vm.pieBg,
      }),attrs:{"aria-hidden":"true"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }